/*
***********************************************
this is added to the _BasicLayout.cshtml file
***********************************************
*/

import ScrollToTop4i from '../../common/scrolltotop25.js';
import ImageError4i from '../../common/imageerror25.js';

//TODO: Uncomment and test these imports
//import KameleoonTest from '../../thirdparty/kameleoon/kameleoontest.js';

async function init() {
    if (!('inert' in HTMLElement.prototype) || !('loading' in HTMLImageElement.prototype)) {
        const { default: banner } = await import('../../common/upgradebrowser.js');
        banner.init();
    }

    if (document.getElementById("needsRecaptcha")) {
        const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptchascript.js');
        recaptcha.init();
    }

    ImageError4i.init();
    ScrollToTop4i.init();

    //todo does this need to be in the head in layout file?
    //todo uncomment and test
    if (document.getElementById("noibuOn")?.value == "true") {
        const { default: noibu } = await import('../../thirdparty/noibu/noibu.js');
        noibu.init();
    }

    if (document.getElementById("includeSiteImproveAnalytics")?.value == "true") {
        const { default: SiteImprove } = await import('../../thirdparty/siteimprove/siteimprove.js');
        SiteImprove.init();
    }

    //todo test all of these
    //KameleoonTest.init(); //todo uncomment and test
}

await init();